import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    items: {
      0: {
        fetched: false
      }
    },
    listPage: null
  },
  getters: {
    items: state => state.items,
    listPage: state => state.listPage
  },
  mutations: {
    updateItem (state, item) {
      Vue.set(state.items, item.id, item)
    },
    addDefault (state, id) {
      Vue.set(state.items, id, {
        fetched: false
      })
    },
    setListPage (state, listPage) {
      state.listPage = listPage
    },
    setListPageUri (state, uri) {
      uri = new URL(uri)

      let page = uri.pathname
      if (uri.search) page += '?' + uri.search

      state.listPage = page
    }
  },
  actions: {
    async updateItem ({ commit, state }, id) {
      if (!(id in state.items)) {
        commit('addDefault', id)
      }

      const fetchDate = state.items[id].fetchedOn
      const diff = new Date() - fetchDate
      const minutes = diff / (1000 * 60)

      if (minutes < 3) {
        return
      }

      const resp = await fetch(`https://hacker-news.firebaseio.com/v0/item/${id}.json`)
      const item = await resp.json()
      if (item == null) {
        const error = new Error('item not found')
        error.code = 'not found'
        throw error
      }

      if (item.type !== 'comment' && item.descendants === undefined) {
        item.descendants = 0
      }

      item.fetchedOn = new Date()
      item.fetched = true

      commit('updateItem', item)
    }
  }
})
